const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// Deterministic date formatter (avoids locale-based hydration mismatches).
export const formatDate = (input: string): string => {
    const date = new Date(input)
    if (Number.isNaN(date.getTime())) return input
    return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
}
